<div class="srch-icon">
    <div class="auto-suggestion-con"> <i class='fas fa-search'></i>
        <input (keyup)="onChange()" type="text" class="searchbox" [(ngModel)]="searchItem" placeholder="Search">
        <i *ngIf="searchItem" class='fas fa-times-circle cross-cst'
            (click)="searchItem = null; filteredItemList=[];"></i>
        <ul class="list-item-cst">
            <li (click)="onSelectedItem(item)" *ngFor="let item of filteredItemList">{{item?.value}}</li>
        </ul>
    </div>
</div>